import { render, staticRenderFns } from "./BurgerIcon.vue?vue&type=template&id=424bba5b&scoped=true&"
import script from "./BurgerIcon.vue?vue&type=script&lang=js&"
export * from "./BurgerIcon.vue?vue&type=script&lang=js&"
import style0 from "./BurgerIcon.vue?vue&type=style&index=0&id=424bba5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424bba5b",
  null
  
)

export default component.exports